<template>
  <div class="map-box">
    <!-- <el-amap
      ref="map"
      :zoom="hasPoints ? zoom : 15"
      :center="[mapCenter.lng, mapCenter.lat]"
      style="width:100%; height:100%;"
    >
      1. 中心点（始终显示）
      <el-amap-marker
				v-if="!showName"
        :position="[mapCenter.lng, mapCenter.lat]"
        :title="mapCenter.name"
        :content="centerIcon"
      />

      2. 景点点（仅在有数据时渲染）
      <el-amap-marker
        v-for="(item, index) in visiblePoints"
        v-if="hasPoints"
        :key="index"
        :position="[item.lng, item.lat]"
        :title="item.name"
        :content="spotIcon(index + 1,item.name)"
      />
		
			</el-amap> -->
  </div>
</template>

<script>
export default {
  name: 'AmapPointsViewer',
  props: {
    mapPoints: { type: Array, default: () => [] }, // 允许空数组
    mapCenter: { type: Object, required: true },
		showName: { type:Boolean, default: false}
  },
  data() {
    return {
      zoom: 12,
    };
  },
  // computed: {
  //   // 安全：始终返回数组，避免 null/undefined
  //   visiblePoints() {
  //     return Array.isArray(this.mapPoints) ? this.mapPoints : (this.mapPoints || []);
  //   },
  //   // 是否有景点
  //   hasPoints() {
  //     return this.visiblePoints.length > 0;
  //   },
  //   centerIcon() {
  //     return `<div style="
  //       width:36px;height:36px;
  //       border:3px solid #fff;
  //       border-radius:50%;
  //       box-shadow:0 2px 6px rgba(0,0,0,.3);
  //       display:flex;align-items:center;justify-content:center;
  //       color:#fff;font-size:20px;">🏨</div>`;
  //   }
  // },
  // methods: {
		
  //   spotIcon(idx,name) {
	// 		if(this.showName){
	// 			return `<div style="
	// 			min-width:32px;      
	// 			height:32px;
	// 			padding:0 8px;           
	// 			background:#1890ff;
	// 			border:2px solid #fff;
	// 			border-radius:16px;      
	// 			box-shadow:0 1px 3px rgba(0,0,0,.2);
	// 			text-align:center;
	// 			line-height:28px;
	// 			color:#fff;
	// 			font-size:12px;
	// 			white-space:nowrap;">${name}</div>`
	// 		}else{
	// 			return `<div style="
  //       width:24px;height:24px;
  //       background:#1890ff;
  //       border:2px solid #fff;
  //       border-radius:50%;
  //       box-shadow:0 1px 3px rgba(0,0,0,.2);
  //       text-align:center;line-height:22px;
  //       color:#fff;font-size:12px;">${idx}</div>`;
	// 		}
  //   },
  // },
};
</script>


// WEBPACK FOOTER //
// src/common/cmpnt/map/Map.vue